import { a } from '../global-constants';

export const setListingsCarouselSlidesCondition = (payload) => {
	return {
		type: a.SET_LISTINGS_CAROUSEL_SLIDE_CONDITIONS,
		payload
	};
};
